import React from 'react';

import classNames from 'classnames';

import { useHawkWidgetContext } from '../GenericComponents/HawkWidget/HawkWidgetProviderContext';

import styles from './styles/tabletop-footer.css';

interface TabletopFooterProps {
  showMore: () => void;
  showLess: () => void;
  visibleCount: number;
  minVisibleCount: number;
  maxVisibleCount: number;
}

const TabletopFooter: React.FC<TabletopFooterProps> = ({
  visibleCount,
  minVisibleCount,
  maxVisibleCount,
  showMore,
  showLess,
}) => {
  const { translate } = useHawkWidgetContext();

  const handleKeyDownMore = (e): void => {
    if (e.key === 'Enter') {
      showMore();
    }
  };
  const handleKeyDownLess = (e): void => {
    if (e.key === 'Enter') {
      showLess();
    }
  };

  return (
    <div
      className={classNames(
        styles['footer'],
        maxVisibleCount <= minVisibleCount && styles['empty'],
      )}
    >
      {visibleCount < maxVisibleCount && (
        <div
          className={styles['footer-button']}
          tabIndex={0}
          onClick={showMore}
          onKeyDown={handleKeyDownMore}
          role="button"
        >
          <span>{translate('showMore')}</span>
          <span className={styles['arrow']}>▼</span>
        </div>
      )}
      {visibleCount > minVisibleCount && (
        <div
          className={styles['footer-button']}
          tabIndex={0}
          onClick={showLess}
          onKeyDown={handleKeyDownLess}
          role="button"
        >
          <span>{translate('showLess')}</span>
          <span className={styles['arrow']}>▲</span>
        </div>
      )}
    </div>
  );
};

export default TabletopFooter;
